import React from "react";

export const SearchListError = ({ error }) => (
  <p>
    <strong>{error?.toString()}</strong>
  </p>
);
